import { c as _c } from "react/compiler-runtime";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import { useMemo } from "react";
export default function CommunityMembersTableSkeleton(t0) {
  const $ = _c(10);
  const {
    rows: t1
  } = t0;
  const rows = t1 === undefined ? 10 : t1;
  let t2;
  if ($[0] !== rows) {
    t2 = Array.from({
      length: rows
    }, _temp);
    $[0] = rows;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const rowKeys = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-h-12 tw-border-b tw-border-iron-700 tw-bg-iron-900" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== rowKeys) {
    t4 = <div className="tw-hidden tw-overflow-hidden tw-rounded-lg tw-bg-iron-950 tw-shadow sm:tw-block sm:tw-border sm:tw-border-solid sm:tw-border-iron-700"><div className="tw-animate-pulse">{t3}{rowKeys.map(_temp2)}</div></div>;
    $[3] = rowKeys;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== rowKeys) {
    t5 = <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-y-3 sm:tw-hidden">{rowKeys.map(_temp3)}</div>;
    $[5] = rowKeys;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp3(key_0) {
  return <div key={key_0} className="tw-flex tw-animate-pulse tw-flex-col tw-gap-y-3 tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900/80 tw-p-3"><div className="tw-flex tw-w-full tw-justify-between"><div className="tw-flex tw-items-center tw-gap-x-2"><div className="tw-h-4 tw-w-6 tw-rounded tw-bg-iron-800" /><div className="tw-h-11 tw-w-11 tw-rounded-md tw-bg-iron-800" /><div className="tw-flex tw-flex-col tw-gap-y-1.5"><div className="tw-h-4 tw-w-28 tw-rounded tw-bg-iron-800" /><div className="tw-h-5 tw-w-16 tw-rounded-full tw-bg-iron-800" /></div></div><div className="tw-h-3 tw-w-20 tw-rounded tw-bg-iron-800" /></div><div className="tw-flex tw-items-center tw-justify-between"><div className="tw-h-4 tw-w-14 tw-rounded tw-bg-iron-800" /><div className="tw-h-4 tw-w-14 tw-rounded tw-bg-iron-800" /><div className="tw-h-4 tw-w-12 tw-rounded tw-bg-iron-800" /><div className="tw-h-4 tw-w-12 tw-rounded tw-bg-iron-800" /></div></div>;
}
function _temp2(key) {
  return <div key={key} className="tw-flex tw-h-16 tw-items-center tw-gap-4 tw-border-b tw-border-iron-800 tw-px-6"><div className="tw-h-4 tw-w-8 tw-rounded tw-bg-iron-800" /><div className="tw-h-8 tw-w-8 tw-rounded-md tw-bg-iron-800" /><div className="tw-h-4 tw-w-24 tw-rounded tw-bg-iron-800" /><div className="tw-h-7 tw-w-7 tw-rounded-full tw-bg-iron-800" /><div className="tw-flex-1" /><div className="tw-h-4 tw-w-14 tw-rounded tw-bg-iron-800" /><div className="tw-h-4 tw-w-14 tw-rounded tw-bg-iron-800" /><div className="tw-h-4 tw-w-12 tw-rounded tw-bg-iron-800" /><div className="tw-h-4 tw-w-12 tw-rounded tw-bg-iron-800" /><div className="tw-h-4 tw-w-16 tw-rounded tw-bg-iron-800" /></div>;
}
function _temp() {
  return getRandomObjectId();
}